import type { VisualPayload } from "../../types";
import CardShell from "./_CardShell";
import RankList, { type RankEntry } from "./_RankList";

interface Props { payload: VisualPayload }

export default function TopNCard({ payload }: Props) {
  const sec = payload.sections.find((s) => s.section === "top_n");
  const entries = (sec?.entries as RankEntry[]) ?? [];

  return (
    <CardShell title={payload.title} source={payload.data_source} timestamp={payload.data_timestamp} sourceUrl={payload.source_url} shareUrl={payload.share_url} snapshotPayload={payload.snapshot_eligible ? payload : undefined}>
      <RankList
        entries={entries}
        empty={<p className="text-sm text-white/40">No rankings found.</p>}
      />
    </CardShell>
  );
}
